import { getData } from "../../../apis/api.helpers";
import apiUrl from "./api.url";

export const getMilestoneDetails = (id:string ) =>
getData(`${apiUrl.MILESTONE_DETAILS}/${id}`).then((res) => res.data);